var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusicn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.323,
    height: 14.323,
    viewBox: "0 0 14.323 14.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plusicn",
    transform: "translate(-1685.75 -186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616",
    transform: "translate(1685.75 186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1916",
    "data-name": "Ellipse 1916",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#32315c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.161,
    cy: 7.161,
    r: 7.161,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.161,
    cy: 7.161,
    r: 6.661,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40300",
    "data-name": "Group 40300",
    transform: "translate(1689.656 189.906)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1029",
    "data-name": "Line 1029",
    y2: 6.51,
    transform: "translate(3.255)",
    fill: "none",
    stroke: "#32315c",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1030",
    "data-name": "Line 1030",
    y2: 6.51,
    transform: "translate(6.51 3.255) rotate(90)",
    fill: "none",
    stroke: "#32315c",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusicn);
export default __webpack_public_path__ + "static/media/plusicn.27778bab020b21906129ca3929620b4b.svg";
export { ForwardRef as ReactComponent };